/** @format */
import React, { FunctionComponent, useState, useEffect, useRef } from 'react'
import styled from 'styled-components'
import { Input, Icon, _$ } from '@king-design/react'
import variable from 'src/static/styles/var'

interface OwnProps {
  className?: string
  placeholder?: string
  defaultValue?: string
  value?: string
  prepend?: any
  disabled?: boolean
  width?: number | string
  hideIcon?: boolean
  prefix?: string
  onChange: (searchValue?: string) => void
}

const MonitorSearch: FunctionComponent<OwnProps> = ({
  className,
  placeholder,
  defaultValue,
  value,
  onChange,
  prepend,
  prefix,
  width,
  disabled,
  hideIcon = false
}) => {
  const [inputValue, setInputValue] = useState<string>(defaultValue || value || '')
  const inputRef = useRef<Input>(null)

  useEffect(() => {
    setInputValue(value)
  }, [value])

  return (
    <Input
      ref={inputRef}
      className={className}
      disabled={disabled}
      width={width}
      clearable
      value={inputValue}
      stackClearIcon
      onClear={() => {
        setInputValue('')
        onChange && onChange('')
        inputRef.current?.blur()
      }}
      onKeyUp={e => {
        if (e.keyCode === 13) {
          inputRef.current?.blur()
        }
      }}
      onBlur={() => {
        onChange && onChange(inputValue)
      }}
      onChangeValue={value => {
        setInputValue(String(value ?? ''))
      }}
      placeholder={placeholder ? _$(placeholder) : _$('输入查询')}
      slotPrepend={prepend || null}
      slotPrefix={prefix || null}
      slotSuffix={
        hideIcon ? undefined : (
          <Icon
            className="k-icon-search"
            onClick={() => {
              onChange && onChange(inputValue)
            }}
          />
        )
      }
    />
  )
}

export default styled(MonitorSearch)`
  .k-icon-search {
    cursor: pointer;
  }
  .k-input-prefix {
    color: ${variable.fontColor};
  }
`
